import { useParams } from "react-router-dom";

import {
  BannerText,
  BannerWrapper,
  BoxImageContainer,
  BoxImageMaisIntegridade,
  BoxImageMapa,
  BoxImageSisbi,
  BoxTextContainer,
  ButtonContatos,
  ContatosESelosContainer,
  DivLegend,
  DivTopo,
  HomeContainer,
  IconImage,
  ImgRecipe,
  InfoCard,
  InfoContainerUm,
  InfoText,
  InfoTitle,
} from "./styles";
import sisbi from "../../../assets/images/SISBI.webp";
import maisIntegridade from "../../../assets/images/mais_integridade.webp";
import mapa from "../../../assets/images/MAPA.webp";
import Footer from "../../../components/footer";
import { useEffect, useState } from "react";
import { iconRendimento, iconTime } from "../../../assets/images";
import { receitas } from "../../../constants/revenues";

const RevenuesDescription = () => {
  const { id } = useParams<{ id: string }>();
  const [receita, setReceita] = useState<any>(null);

  useEffect(() => {
    const foundReceita = receitas.find((rec) => rec.id === Number(id));
    setReceita(foundReceita);
  }, [id]);

  return (
    <HomeContainer>
      <BannerWrapper>
        <BannerText>
          Receitas <br /> Suprema
        </BannerText>
      </BannerWrapper>

      <InfoContainerUm>
        <ImgRecipe src={receita?.image} alt={receita?.title} />
        <DivLegend>
          <DivTopo
            style={{
              backgroundColor: "#881c15",
              boxShadow: "0 0 10px #000",
              marginTop: "-50px",
              zIndex: 3,
            }}
          >
            <h2 style={{ color: "#fff" }}>{receita?.title}</h2>
          </DivTopo>
          <DivTopo style={{ gap: "20px" }}>
            <div
              style={{
                display: "flex",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <IconImage src={iconRendimento} alt={receita?.rendimento} />
              <h2
                style={{
                  color: "#000",
                  margin: "0",
                  fontSize: "24px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#881C15",
                  }}
                >
                  Rendimento
                </span>
                {receita?.rendimento}
              </h2>
            </div>

            <div
              style={{
                display: "flex",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <IconImage src={iconTime} alt={receita?.tempo_preparo} />
              <h2
                style={{
                  color: "#000",
                  margin: "0",
                  fontSize: "24px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#881C15",
                  }}
                >
                  Tempo de preparo
                </span>
                {receita?.tempo_preparo}
              </h2>
            </div>
          </DivTopo>
        </DivLegend>

        <InfoCard>
          <InfoTitle>Ingredientes</InfoTitle>
          <InfoText>
            {receita?.ingredients.map((item: string, index: number) => (
              <span key={index}>
                • {item}
                <br />
              </span>
            ))}
          </InfoText>
        </InfoCard>

        <InfoCard>
          <InfoTitle>Modo de preparo</InfoTitle>
          <InfoText>
            {receita?.modo_preparo.map((item: string, index: number) => (
              <span key={index}>
                {index + 1}. {item}
                <br />
              </span>
            ))}
          </InfoText>
        </InfoCard>

        <InfoCard>
          <InfoTitle>Como dessalgar a charque</InfoTitle>
          <InfoText>
            A charque precisa ser dessalgada corretamente para equilibrar os
            sabores e garantir uma textura macia. Se estiver em peças grandes,
            corte em pedaços menores para acelerar o processo. Depois, coloque a
            carne em um recipiente com água fria, cobrindo totalmente. Deixe de
            molho por 12 a 24 horas, trocando a água a cada 4 horas. Quanto mais
            tempo de molho, menos salgada ela ficará, ok?
          </InfoText>
        </InfoCard>
      </InfoContainerUm>

      <ContatosESelosContainer>
        <BoxTextContainer>
          <div>
            <h2>Vamos fazer negócios?</h2>
            <p>Fale com um especialista</p>
          </div>
          <ButtonContatos
            onClick={() => {
              window.location.href = "/contact-us";
            }}
          >
            CONTATO
          </ButtonContatos>
        </BoxTextContainer>
        <BoxImageContainer>
          <BoxImageSisbi src={sisbi} alt="SISBI" />
          <BoxImageMaisIntegridade src={maisIntegridade} />
          <BoxImageMapa src={mapa} alt="Mapa" />
        </BoxImageContainer>
      </ContatosESelosContainer>

      <Footer />
    </HomeContainer>
  );
};
export default RevenuesDescription;
